import type Axios from "axios";
import {axiosInstance} from "../../api";
import type {
	HelpPointCategory,
	HelpPointLinkModel,
	HelpPointPlaylist,
	HelpPointPlaylistItem,
	HelpPointVideo
} from "../model";
import {HelpPointLinkIdentifier} from "../model";

class HelpPointService {
	api: Axios;

	constructor(api: Axios) {
		this.api = api;
	}

	async getCategories(): Promise<HelpPointCategory[]> {
		return await this.api.get("/helpPoint/category")
			.then(response => response.data);
	}

	async getNewestPlaylistItems(): Promise<HelpPointPlaylistItem[]> {
		return await this.api.get("/helpPoint/playlist/item/orderedByVideoReleaseDate", {
			params: {size: 16}
		})
			.then(response => response.data);
	}

	async getVideoDetails(id: number): Promise<HelpPointVideo> {
		return await this.api.get(`/helpPoint/video/${id}`)
			.then(response => response.data);
	}

	async getPlaylistByVideoId(id: number): Promise<HelpPointPlaylist> {
		return await this.api.get(`/helpPoint/playlist/byVideoId/${id}`)
			.then(response => response.data);
	}

	async getHelpPointLinkByIdentifier(linkIdentifier: HelpPointLinkIdentifier): Promise<HelpPointLinkModel> {
		return await this.api.get("/helpPoint/link/byLinkIdentifier", {
			params: {linkIdentifier: linkIdentifier}
		})
			.then(response => response.data);
	}
}

const HelpPointServiceInstance = new HelpPointService(axiosInstance);
export default HelpPointServiceInstance;